define [], () ->
  ($scope, $state, $stateParams, $rootScope) ->
    $scope.fail_svg = require('./error-illustration.svg')
    $scope.context = $stateParams.context
    $scope.application_id = $stateParams.application_id
    $scope.application = $stateParams.application
    $scope.vendor = $stateParams.vendor

    $scope.vendor_name = if $scope.vendor == 'smartmove' then 'Transunion' else 'Experian'

    $scope.continue_app = () ->
      if $scope.application.need_applicant_finicity_bank_connection
        $state.go("root.applications.income", {application_id: $stateParams.application_id, application: $scope.application })
      else
        $state.go "root.applications.apply_success", { application_id: $scope.application_id, application: $scope.application }

    $scope.continue = () ->
      if $rootScope.stored_form_data
        $state.go "root.forms.select_reports"
      else
        $state.go "root.dashboard.forms"



// WEBPACK FOOTER //
// ./components/verifications/fail/fail.coffee